import { render, staticRenderFns } from "./Tipo.vue?vue&type=template&id=131f3484"
import script from "./Tipo.vue?vue&type=script&lang=js"
export * from "./Tipo.vue?vue&type=script&lang=js"
import style0 from "./Tipo.vue?vue&type=style&index=0&id=131f3484&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports